import axios from "../../plugins/axios-common"
export default {
	actions: {
		fetchCarMarks({commit}) {
			axios.get('/cars-db/marks').then((resp) => {
				const carMarks = resp.data
				commit('updateCarMarks', carMarks)
				commit('updateCarMarksFull', carMarks)
			}).catch((error) => {
				//TODO: catch not found
				console.log('Error fetching car models', error)
			})
		},
		fetchCarModels({commit}, chosenMark) {
			// const body = { searchString: chosenMark }
			return new Promise((resolve, reject) => {
				const settings = {
					method: 'GET',
					// url: '/client/carmarks.json',
					url: `/cars-db/models/${chosenMark}`,
					// data: body,
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json',
					}
				}
				axios(settings).then((resp) => {
					const carModels = resp.data
					commit('updateCarModels', carModels)
					resolve(carModels)
				}).catch((error) => {
					//TODO: catch not found
					reject(error)
					console.log('Error fetching car models', error)
				})
			})
		},
		fetchCarTypes({commit}) {
			// const body = { searchString: chosenMark }
			const settings = {
				method: 'GET',
				// url: '/client/carmarks.json',
				url: `/cars-db/type`,
				// data: body,
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				}
			}
			axios(settings).then((resp) => {
				console.log('000000', resp.data)
				commit('updateCarTypes', resp.data)
			}).catch((error) => {
				//TODO: catch not found
				console.log('Error fetching car models', error)
			})
		},
		//fetchCarSTypesByService
		fetchCarSTypesByService({commit}) {
			// const body = { searchString: chosenMark }
			const settings = {
				method: 'GET',
				// url: '/client/carmarks.json',
				url: `/cars-db/type`,
				// data: body,
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				}
			}
			axios(settings).then((resp) => {
				console.log('000000', resp.data)
				commit('updateCarTypesByService', resp.data)
			}).catch((error) => {
				//TODO: catch not found
				console.log('Error fetching car models', error)
			})
		},
		addClientCar({commit, state} , payload) {
			return new Promise((resolve, reject) => {
				const body = {
					'carMark': state.chosenMark,
					'carModel': state.chosenModel,
					'plate_number': payload.plate_number,
					'userId': payload.userId
				}
				const settings = {
					method: 'POST',
					data: body,
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
					}
				}
				axios('client/clientcars.json', settings).then((resp) => {
					const cars = resp.data
					commit('updateClientCars', cars)
					resolve(cars)
				}).catch((error) => {
					this.dispatch('sendNotification', {quote: error, type: 'danger'})
					reject(error)
				})
			})
		}
	},
	mutations: {
		updateCarMarks(state, carMarks) {
			state.carMarks = carMarks
		},
		updateCarMarksFull(state, carMarks) {
			state.carMarksFull = carMarks
		},
		updateCarModels(state, carModels) {
			state.carModels = carModels
		},
		updateCarTypes(state, carTypes) {
			state.carTypes = carTypes
		},
		updateCarTypesByService(state, carTypes) {
			state.carTypesByService = carTypes
		},
		updateChosenMark(state, chosenMark) {
			state.chosenMark = chosenMark
		},
		updateChosenModel(state, chosenModel) {
			state.chosenModel = chosenModel
		},
		updateChosenCarId(state, chosenCarId) {
			state.chosenCarId = chosenCarId
		},
		updateCarType(state, carType) {
			state.carType = carType
		},
		updateCarTypeArr(state, carType) {
			state.carTypeArr = carType
		},
		updateDiskType(state, diskType) {
			state.diskType = diskType
		},
		updateRunflat(state, runflat) {
			state.runflat = runflat
		},
		updateFrameVehicle(state, frameVehicle) {
			state.frameVehicle = frameVehicle
		},
		updateDiskSize(state, diskSize) {
			state.diskSize = diskSize
		},
		updatePlateNumber(state, plateNumber) {
			state.plateNumber = plateNumber
		},
		resetCarData(state) {
			state.chosenMark = ''
			state.chosenModel = ''
			state.carType = ''
			state.diskType = ''
			state.diskSize = ''
			state.runflat = false
			state.frameVehicle = false
			state.plateNumber = ''
		}
	},
	state: {
		carMarks: {},
		carMarksFull: {},
		carModels: {},
		carTypes: null,
		carTypesByService: null,
		chosenMark: '',
		chosenModel: '',
		chosenCarId: '',
		carType: '',
		carTypeArr: [],
		diskType: '',
		runflat: false,
		frameVehicle: false,
		diskSize: '',
		plateNumber: '',
	},
	getters: {
		carTypes(state) {
			return state.carTypes
		},
		carTypesByService(state) {
			return state.carTypesByService
		},
		carTypeArr(state) {
			return state.carTypeArr
		},
		carMarks(state) {
			return state.carMarks
		},
		carMarksModels(state) {
			return state.carMarksFull
		},
		carModels(state) {
			return state.carModels
		},
		chosenMark(state) {
			return state.chosenMark
		},
		chosenModel(state) {
			return state.chosenModel
		},
		carType(state) {
			return state.carType
		},
		diskType(state) {
			return state.diskType
		},
		runflat(state) {
			return state.runflat
		},
		frameVehicle(state) {
			return state.frameVehicle
		},
		diskSize(state) {
			return state.diskSize
		},
		plateNumber(state) {
			return state.plateNumber
		}
	}
}
